import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WebsiteRoutes from "./website_routes";
import UserRoutes from "./user_routes";
import NotFound from "../components/Reusable/Notfound";
import AdminRoutes from "./admin_routes";
import OrganisationRoutes from "./oganisation_routes";
import ScrollToTop from "../components/Reusable/ScrollToTop";

function AppRoutes() {
  return (
    <Router>
      <ScrollToTop /> {/* ensures all pages scroll to top on route change */}
      <Routes>
        <Route path="/*" element={<WebsiteRoutes />} />
        <Route path="/user/*" element={<UserRoutes />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/org/*" element={<OrganisationRoutes />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
